module.exports = __webpack_public_path__ + "static/media/p4.a17d4a92.png";